import React from 'react';
import type { Team } from '@sulis-liiga/common';

interface PartnerRequestsListProps {
  requests: Team[];
  onAccept: (teamId: string) => void;
  onDecline: (teamId: string) => void;
  loading?: boolean;
}

const PartnerRequestsList: React.FC<PartnerRequestsListProps> = ({
  requests,
  onAccept,
  onDecline,
  loading = false,
}) => {
  if (requests.length === 0) {
    return <p className="text-sm text-gray-500">No incoming partner requests.</p>;
  }

  return (
    <ul className="space-y-3">
      {requests.map(team => (
        <li
          key={team.id}
          className="flex items-center justify-between rounded-lg border border-gray-200 bg-white px-4 py-3 shadow-sm"
        >
          <div>
            <p className="text-sm font-medium text-gray-900">{team.name}</p>
            <p className="text-xs text-gray-500 capitalize">{team.type.replace('_', ' ')}</p>
          </div>
          <div className="flex space-x-2">
            <button
              type="button"
              disabled={loading}
              onClick={() => onAccept(team.id)}
              className="rounded-md bg-primary-600 px-3 py-1 text-xs font-medium text-white hover:bg-primary-700 disabled:opacity-50"
            >
              Accept
            </button>
            <button
              type="button"
              disabled={loading}
              onClick={() => onDecline(team.id)}
              className="rounded-md border border-gray-300 bg-white px-3 py-1 text-xs font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
            >
              Decline
            </button>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default PartnerRequestsList;
